import Advance from '@assets/icons/advance.svg'
import { Icon } from './Icon'

export const AdvanceIcon = Icon(Advance)
